import * as actionTypes from "./actionTypes";

export const sendThieves = (
  actionType: number,
  targetId: number,
  influence: number,
  sender: number,
  isOwner: boolean
) => ({
  type: actionTypes.SEND_THIEVES,
  actionType,
  targetId,
  influence,
  sender,
  isOwner
})

export const cancelThieves = (
  actionType: number,
  targetId: number,
  sender: number,
  isOwner: boolean
) => ({
  type: actionTypes.CANCEL_THIEVES,
  actionType,
  targetId,
  sender,
  isOwner
})
